module.exports = __webpack_public_path__ + "img/logo.3f1b9c5a.png";